import { Component, OnInit, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { faCircleInfo, faClose, faFile, faPlus, faTrash } from '@fortawesome/pro-regular-svg-icons';

import { FileType, FileTypeExtension } from '@empathy/global/data';
import { CustomTerm } from '@empathy/survey/base';

import { FilePreview } from '../../../models/stimulus/file-preview.interface';

@Component({
  selector: 'empathy-import-csv-dialog',
  templateUrl: 'import-csv-dialog.component.html',
  styleUrls: ['./import-csv-dialog.component.scss']
})
export class ImportCsvDialogComponent implements OnInit {
  badFormattedCsv$ = signal<boolean>(false);
  uploadedFilePreview$ = signal<FilePreview>(null);
  uploadedFile$ = signal<CustomTerm[]>(null);

  faCircleInfo = faCircleInfo;
  faClose = faClose;
  faFile = faFile;
  faPlus = faPlus;
  faTrash = faTrash;
  fileType = FileType;
  fileTypeExtension = FileTypeExtension;

  constructor(private dialogRef: MatDialogRef<ImportCsvDialogComponent, CustomTerm[]>) {}

  ngOnInit(): void {
    this.dialogRef.updateSize('560px');
    this.dialogRef.disableClose = true;
  }

  onImport(): void {
    this.dialogRef.close(this.uploadedFile$());
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onUpload(file: File): void {
    this.badFormattedCsv$.set(false);
    const reader = new FileReader();
    reader.onload = (e): void => {
      const filePreview: FilePreview = {
        file: file,
        size: (file.size / (1024 * 1024)).toFixed(2),
        src: e.target?.result as string | ArrayBuffer,
        failed: false
      };

      const csvContent = e.target.result as string;
      const parsedData = this.parseCsv(csvContent);

      this.uploadedFile$.set(parsedData);
      this.uploadedFilePreview$.set(filePreview);

      if ((this.uploadedFilePreview$().src as string).split('\r\n').filter((s) => s !== '').length > this.uploadedFile$().length) {
        this.badFormattedCsv$.set(true);
      }
    };
    reader.readAsText(file);
  }

  onDelete(): void {
    this.uploadedFilePreview$.set(null);
  }

  parseCsv(csvContent: string): CustomTerm[] {
    const lines = csvContent.split('\n');
    const headers = ['term', 'type'];
    const result: CustomTerm[] = [];

    for (let i = 0; i < lines.length; i++) {
      const obj: any = {};
      const currentLine = lines[i].split(',');

      if (currentLine.length === headers.length) {
        let canAdd = true;
        for (let j = 0; j < headers.length; j++) {
          if (headers[j].trim() === 'type' && currentLine[j].trim() !== 'exact' && currentLine[j].trim() !== 'contains') {
            canAdd = false;
          } else {
            obj[headers[j].trim()] = currentLine[j].trim();
          }
        }

        if (canAdd) {
          result.push(obj);
        }
      }
    }

    return result;
  }
}
